var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12a9 9 0 1 1 9 9 8.93 8.93 0 0 1-5.403-1.807 5.275 5.275 0 0 1-.183-.146c-.435-.361-.44-1.02-.04-1.421.381-.382.989-.381 1.413-.049l.057.044A6.93 6.93 0 0 0 13 19c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7h3l-4.04 4.03L1 12h3Z",
    fill: "#262D38"
  })));
};
export default SvgUndo;